import type { DashboardLayoutState } from './useDashboardLayout';

/** Reorder dashboard cards by index, optionally within visible cards only. */
export function reorderDashboardOrder<TId extends string>(
  layout: DashboardLayoutState<TId>,
  fromIndex: number,
  toIndex: number,
  options?: { visibleOnly?: boolean }
): DashboardLayoutState<TId> {
  if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) {
    return layout;
  }

  const visibleOnly = options?.visibleOnly ?? false;

  if (visibleOnly) {
    const hidden = new Set(layout.hidden);
    const visibleOrder = layout.order.filter((id) => !hidden.has(id));
    if (fromIndex >= visibleOrder.length || toIndex >= visibleOrder.length) {
      return layout;
    }

    const nextVisible = [...visibleOrder];
    const [moved] = nextVisible.splice(fromIndex, 1);
    nextVisible.splice(toIndex, 0, moved);

    let visibleIndex = 0;
    const order = layout.order.map((id) => (hidden.has(id) ? id : nextVisible[visibleIndex++]));
    return { ...layout, order };
  }

  if (fromIndex >= layout.order.length || toIndex >= layout.order.length) {
    return layout;
  }

  const order = [...layout.order];
  const [moved] = order.splice(fromIndex, 1);
  order.splice(toIndex, 0, moved);
  return { ...layout, order };
}
